export default {"src":"/_next/static/media/grispi.7af9380d.gif","height":120,"width":300,"blurWidth":0,"blurHeight":0};